import { createSlice } from "@reduxjs/toolkit";
import type { CatCrane } from "../../models/CatCrane";

const CraneInitialState: {
  cranes: CatCrane[] | null;
} = {
  cranes: null,
};

export const CraneReducer = createSlice({
  name: "__",
  initialState: CraneInitialState,
  reducers: {
    setCranes(state, { payload }) {
      state.cranes = payload;
    },
  },
});
